import { Image } from "antd";
import { TicketDetails } from "../../../../../../features/superAdmin/ticketService/ticket/ticket.type";

export default function DetailsSpecification({
  ticket,
}: {
  ticket: TicketDetails;
}) {
  const fields = ticket?.requiredFields?.filter(
    (item: any) => item.photo_urls === null,
  );
  const attachments = ticket?.requiredFields?.filter(
    (item: any) => item.photo_urls !== null,
  );
  return (
    <>
      <div className="shadow rounded-md p-4 overflow-auto mb-6">
        {Array.from({
          length: Math?.ceil((fields?.length || 0) / 3),
        }).map((_, rowIndex) => {
          const startIndex = rowIndex * 3;
          const rowItems = fields?.slice(startIndex, startIndex + 3);
          const isLastRow = startIndex + 3 >= (fields?.length || 0);

          return (
            <div
              key={rowIndex}
              className={`grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2 w-full py-2 ${
                !isLastRow ? "border-b border-slate-200" : ""
              }`}
            >
              {rowItems?.map((item: any, index: number) => {
                const isLastItemInLastRow =
                  isLastRow && index === rowItems.length - 1;
                const totalItemsInLastRow = rowItems.length;

                let colSpanClass = "";
                if (isLastItemInLastRow) {
                  if (totalItemsInLastRow === 1) colSpanClass = "md:col-span-3";
                  else if (totalItemsInLastRow === 2)
                    colSpanClass = "md:col-span-2";
                }
                return (
                  <div className={`font-medium ${colSpanClass}`} key={index}>
                    <span className="text-base block text-[#5E718D]">
                      {item?.question_text}
                    </span>
                    {item?.value ? (
                      <span className="block text-lg">{item?.value}</span>
                    ) : (
                      item?.options?.map((itemOp: any, indexOp: number) => (
                        <span className="block text-lg" key={indexOp}>
                          {itemOp?.required_field_option}
                        </span>
                      ))
                    )}
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>

      {!!attachments?.length && (
        <div className="shadow rounded-md p-4 overflow-auto">
          {attachments?.map((item: any, index: number) => {
            return (
              <div className="" key={index}>
                <div className="">{item?.question_text}</div>
                <div className="flex justify-start items-center flex-wrap gap-2">
                  {item?.photo_urls?.map(
                    (itemPhoto: any, indexPhoto: number) => (
                      <div key={indexPhoto}>
                        <Image
                          src={itemPhoto}
                          alt="attachment_image"
                          height={150}
                          width={150}
                          className="object-cover rounded border border-light"
                        />
                      </div>
                    ),
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </>
  );
}
